import { ifAuthenticated } from '../before'

export const managementRouteNames = {
  PublicationsApproveRoute: 'PublicationsApproveRoute',
  AffiliationsConfigRoute: 'AffiliationsConfigRoute',
  MergeUsersRoute: 'MergeUsersRoute',
  AuthorsRoute: 'AuthorsRoute',
  PublicationsDuplicatesRoute: 'PublicationsDuplicatesRoute',
  PublicationsRequestsRoute: 'PublicationsRequestsRoute'
}
const rn = managementRouteNames

export const managementRouteURLs = {
  [rn.PublicationsApproveRoute]: '/management/publications',
  [rn.AffiliationsConfigRoute]: '/management/aff-config',
  [rn.MergeUsersRoute]: '/management/merge-users',
  [rn.AuthorsRoute]: '/management/authors',
  [rn.PublicationsDuplicatesRoute]: '/management/duplicates',
  [rn.PublicationsRequestsRoute]: '/management/edit-requests'
}

export const managementPages = [
  {
    path: managementRouteURLs[rn.PublicationsApproveRoute],
    name: rn.PublicationsApproveRoute,
    meta: {
      sidebar: {
        icon: ['far', 'check-square'],
        isDisplay: true
      },
      navbar: {
        group: 'Управление',
        displayName: 'Подтверждение публикаций'
      }
    },
    beforeEnter: ifAuthenticated,
    component: () =>
      import(
        /* webpackChunkName: "PublicationsApproveRoute" */ '@/views/management/PublicationsApproveRoute.vue'
      )
  },
  {
    path: managementRouteURLs[rn.PublicationsDuplicatesRoute],
    name: rn.PublicationsDuplicatesRoute,
    meta: {
      sidebar: {
        icon: ['far', 'copy'],
        isDisplay: true
      },
      navbar: {
        group: 'Управление',
        displayName: 'Объединение публикаций'
      }
    },
    beforeEnter: ifAuthenticated,
    component: () =>
      import(
        /* webpackChunkName: "PublicationsDuplicatesRoute" */ '@/views/management/PublicationsDuplicatesRoute.vue'
      )
  },
  {
    path: managementRouteURLs[rn.PublicationsRequestsRoute],
    name: rn.PublicationsRequestsRoute,
    meta: {
      sidebar: {
        icon: ['fa', 'edit'],
        isDisplay: true
      },
      navbar: {
        group: 'Управление',
        displayName: 'Заявки на редактирование'
      }
    },
    beforeEnter: ifAuthenticated,
    component: () =>
      import(
        /* webpackChunkName: "PublicationsRequestsRoute" */ '@/views/management/PublicationsRequestsRoute.vue'
      )
  },
  {
    path: managementRouteURLs[rn.AffiliationsConfigRoute],
    name: rn.AffiliationsConfigRoute,
    meta: {
      sidebar: {
        icon: ['fa', 'code'],
        isDisplay: true
      },
      navbar: {
        group: 'Управление',
        displayName: 'Конфигуратор аффилиаций'
      },
      breadcrumbs: null
    },
    beforeEnter: ifAuthenticated,
    component: () =>
      import(
        /* webpackChunkName: "AffiliationsConfigRoute" */ '@/views/admin/AffiliationsConfigRoute.vue'
      )
  },
  {
    path: managementRouteURLs[rn.AuthorsRoute],
    name: rn.AuthorsRoute,
    meta: {
      sidebar: {
        icon: ['fa', 'users'],
        isDisplay: true
      },
      navbar: {
        group: 'Управление',
        displayName: 'Сопоставление авторов'
      },
      breadcrumbs: null
    },
    beforeEnter: ifAuthenticated,
    component: () =>
      import(
        /* webpackChunkName: "AuthorsRoute" */ '@/views/management/AuthorsRoute.vue'
      )
  },
  {
    path: managementRouteURLs[rn.MergeUsersRoute],
    name: rn.MergeUsersRoute,
    meta: {
      sidebar: {
        icon: ['fa', 'users'],
        isDisplay: true
      },
      navbar: {
        group: 'Управление',
        displayName: 'Объединение пользователей'
      },
      breadcrumbs: null
    },
    beforeEnter: ifAuthenticated,
    component: () =>
      import(
        /* webpackChunkName: "MergeUsersRoute" */ '@/views/admin/MergeUsersRoute.vue'
      )
  }
]
